import { Box } from '@chakra-ui/react/box'
import { IconButton } from '@chakra-ui/react/button'
import { Flex } from '@chakra-ui/react/flex'
import { Text } from '@chakra-ui/react/text'

import CloseIconFilled from '@/icons/CloseIconFilled'

import classes from './styles.module.css'

interface OfferTooltipProps {
  onClose: () => void
}

export const OfferTooltip = ({ onClose }: OfferTooltipProps) => {
  return (
    <Box className={classes.container}>
      <Box className={classes.bubble}>
        <Flex className={classes.row}>
          <Text className={classes.text}>
            Начислим баллы лояльности в течении 48 часов, если задание будет
            выполнено. Отслеживайте пополнение в личном кабинете «X5 Клуба» в
            разделе История начислений.
          </Text>

          <IconButton
            aria-label="Закрыть подсказку"
            size="xs"
            onClick={onClose}
            className={classes.closeBtn}
          >
            <CloseIconFilled className={classes.closeIcon} />
          </IconButton>
        </Flex>
      </Box>
    </Box>
  )
}
